<template>
    <api-delivery-card :icon="faLinkSimple">
        <template v-slot:title>
            Request Metadata
        </template>
        <template v-slot:content>
            <div  v-if="props.request === undefined" class="w-full flex items-center justify-center">
                <vx-icon-loading spin></vx-icon-loading>
            </div>
            <div v-else-if="props.request" class="justify-start items-center gap-4 inline-flex break-all flex-wrap">
                <vx-badge :color="colorForHttpMethod(props.request.request_method)">
                    {{ props.request.request_method }}
                </vx-badge>
                <div class="text-slate-500 text-base font-normal">{{ props.request.request_content_type }}</div>
                <div class="text-slate-500 text-base font-normal">{{ props.request.request_uri }}</div>
            </div>
            <div v-else
                    class="w-full p-4 bg-slate-50 rounded-[10px] justify-start items-center gap-3 inline-flex">
                    <font-awesome-icon widthAuto :icon="faGhost" class="text-slate-500" />
                    <div class="text-sky-950 text-sm font-normal">Request Missing</div>
            </div>
        </template>
    </api-delivery-card>
</template>
<script setup>
import ApiDeliveryCard from './ApiDeliveryCard.vue';
import { colorForHttpMethod } from '../../../apiDestinationHelper';

import { VxBadge, VxIconLoading } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faLinkSimple, faGhost } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
    request: {
        type: Object,
        required: false,
    }
});

</script>
